import app from '@frontastic/catwalk/src/js/app/app';
import { useCallback, useState } from 'react';
import { useCartContext } from '../../../provider/cart/CartContext';

const usePromoCode = () => {
  const [isClickPromotion, setPromotion] = useState(false);
  const { addDiscountToCart, promoState, resetPromoState } = useCartContext();

  const onClickPromotion = useCallback(() => {
    app.getStore().dispatch({
      type: 'UI.discountMessageUpdate',
      data: {
        type: null,
        message: {},
      },
    });
    setPromotion(true);
  }, []);

  const setCode = useCallback((promoCode) => {
    addDiscountToCart(promoCode);
  }, []);

  return {
    promoState,
    isClickPromotion,
    setPromotion,
    onClickPromotion,
    setCode,
    resetPromoState,
  };
};

export default usePromoCode;
